
// import { EmployeeFreebiesResponse, EmployeeTokenConsumptionReportResponse, FreebieIdRequest, SummaryReportResponse, TokenPrintResponse } from '@cmg/shared-models-and-services';
import { EmployeeFreebiesResponse, EmployeeTokenConsumptionReportResponse, FreebieIdRequest, FreebiesResponse, SummaryReportResponse, TokenPrintModel, TokenPrintResponse } from '@gtpl/shared-models/canteen-management';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ConsumeTokenRequest, EmployeeCodesRequest } from './dto';
import { EmployeeFreebiesAssignRequest } from './dto/employee-freebies-assign.request';
import { EmployeeTokenConsumptionReportRequest } from './dto/employee-token-cons-report.request';
import { SummaryReportRequest } from './dto/token-consumption-summary-report.request';
import { TokenConsumptionService } from './token-consumption.service';
import { TokensService } from './tokens.service';


@ApiTags('freebies-mapping-consumption')
@Controller('freebies-mapping-consumption')
export class TokensController {
    constructor(
        private tokensService: TokensService,
        private tokenConsService: TokenConsumptionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }

    /**
     * creates the employee freebies
     * @returns 
     */
    // @Post('/createEmployeeFreebies')
    // async createEmployeeFreebies(@Body() employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest[]): Promise<EmployeeFreebiesResponse> {
    //     try {
    //         return await this.tokensService.createEmployeeFreebies(employeeFreebiesAssignRes);
    //     }
    //      catch (error) {
    //         return this.applicationExceptionHandler.returnException(EmployeeFreebiesResponse, error);
    //     }
    // }

    @Post('/createToken')
    async createToken(@Body() employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        try {
            return await this.tokensService.createToken(employeeFreebiesAssignRes);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeFreebiesResponse, error);
        }
    }

    /**
     * updates the employee freebies
     * @returns 
     */
    @Post('/updateEmployeeFreebies')
    async updateEmployeeFreebies(@Body() employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        try {
            return await this.tokensService.updateEmployeeFreebies(employeeFreebiesAssignRes);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeFreebiesResponse, error);
        }
    }

    /**
     * gets the employee freebies for the given employee code
     * @param employeeCodeReq 
     */
    @Post('/getEmployeeFreebies')
    async getEmployeeFreebies(@Body() employeeCodesReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        try {
            return await this.tokensService.getEmployeeFreebies(employeeCodesReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeFreebiesResponse, error);
        }
    }

    @Post('/getAllEmployeeFreebies')
    async getAllEmployeeFreebies(): Promise<CommonResponse> {
        try {
            return await this.tokensService.getAllEmployeeFreebies();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * deletes the employee freebies
     * @param employeeCodeReq 
     */
    @Post('/deleteEmployeeFreebies')
    async deleteEmployeeFreebies(@Body() employeeCodesReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        try {
            return await this.tokensService.deleteEmployeeFreebies(employeeCodesReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeFreebiesResponse, error);
        }
    }

    /**
     * consumes an available token if any for the RF id
     * @param consumeTokenRequest 
     * @returns 
     */
    // @Body() consumeTokenRequest: ConsumeTokenRequest
    @Get('consumeToken/:employeeCode/:deviceRfId/:scanTime')
    async consumeToken(@Param() params: { employeeCode: string, deviceRfId: string, scanTime: string }): Promise<TokenPrintResponse> {
        try {
            return await this.tokenConsService.consumeEmployeeToken(params);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(TokenPrintResponse, error);
        }
    }

    /**
     * gets the employee token consumption report
     * @param empTokenConsReportReq
     */
    @Post('/getEmployeeTokenConsumptionReport')
    async getEmployeeTokenConsumptionReport(@Body() empTokenConsReportReq: EmployeeTokenConsumptionReportRequest): Promise<EmployeeTokenConsumptionReportResponse> {
        try {
            return await this.tokenConsService.getEmployeeTokenConsumptionReport(empTokenConsReportReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeTokenConsumptionReportResponse, error);
        }
    }

    /**
     * gets the employee token consumption report
     * @param summaryReportReq
     */
    @Post('/getTokenConsumptionSummaryReport')
    async getTokenConsumptionSummaryReport(@Body() summaryReportReq: SummaryReportRequest): Promise<SummaryReportResponse> {
        try {
            return await this.tokenConsService.getTokenConsumptionSummaryReport(summaryReportReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(SummaryReportResponse, error);
        }
    }

    @Post('/checkEmployeewithfrbId')
    async checkEmployeewithfrbId(@Body() freebieId: FreebieIdRequest): Promise<boolean> {
        try {
            return await this.tokensService.checkEmployeewithfrbId(freebieId);
        } catch (error) {
            return false;
        }
    }

    @Post('/sendDailyTokenConsumptionStatus')
    async sendDailyTokenConsumptionStatus(): Promise<CommonResponse> {
        try {
            return await this.tokensService.sendDailyTokenConsumptionStatus();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/ActivateorDeactivateToken')
    async ActivateorDeactivateToken(@Body() req:EmployeeCodesRequest): Promise<FreebiesResponse> {
        try {
            return await this.tokensService.ActivateorDeactivateToken(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    @Get('/printReceipt/:employeeCode /:employeeName /:freebieCategory/:tokenDate /:consumedTokens /:availableTokens /:tokenStartsAt /:tokenExpiresAt/:price ')
    async printReceipt(@Param () params : {employeeCode: string,employeeName: string,freebieCategory: string,tokenDate: string,consumedTokens: number,availableTokens: number,tokenStartsAt: string,tokenExpiresAt: string,price: number}): Promise<any> {
            const req = new TokenPrintModel(params.employeeCode ,params.employeeName ,params.freebieCategory,params.tokenDate ,params.consumedTokens ,params.availableTokens, params.tokenStartsAt ,params.tokenExpiresAt,params.price )
            return await this.tokenConsService.printReceipt(req);
    }

    @Get('/printUsbReceipt')
    async printUsbReceipt(@Body() req:any): Promise<any> {
            return await this.tokenConsService.printReceipt(req);
    }

    @Post('/freebiesMapping')
    async freebiesMapping(): Promise<CommonResponse> {
        try {
            return await this.tokenConsService.freebiesMapping();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

}
